import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { trigger, style, animate, transition } from '@angular/animations';

import { AuthService } from './pages/auth/auth.service';
import { AUTH_PATHS } from './pages/auth/auth';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [trigger('routeAnimations', [transition('*<=>*', [style({ opacity: 0 }), animate('0.3s', style({ opacity: 1 }))])])],
  standalone: false,
})
export class AppComponent implements OnInit {
  authLoading = false;
  isShow: boolean;
  topPosToStartShowing = 100;

  @HostListener('window:scroll')
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isShow = scrollPosition >= this.topPosToStartShowing;
  }

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.subscribeLocalStorageEvents();
    this.authService.subscribeAuthData().subscribe((authData) => {});
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  subscribeLocalStorageEvents() {
    window.addEventListener('storage', (event) => {
      if (event && event.storageArea === localStorage && event.key === 'changeRole') {
        window.location.reload();
      }

      if (event && event.storageArea === localStorage && event.key === 'logout') {
        this.authService.resetSessionData();
        window.location.href = window.location.origin + '/#/' + AUTH_PATHS.login;
      }
    });
  }

  gotoTop(): void {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  update() {
    setTimeout(() => document.dispatchEvent(new Event('scroll', { bubbles: true, cancelable: false })));
  }
}
